<template>
  <el-row>
    <el-table
      :data="providers"
      border
      style="width: 100%">
      <el-table-column
        prop="id"
        label="编号"
        width="80">
        <template slot-scope="scope">
          <router-link :to="{path: '/provider/details', query: {id: scope.row.id}}">{{scope.row.id}}</router-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="名称">
      </el-table-column>
      <el-table-column
        prop="types"
        label="类型">
        <template slot-scope="scope">
          {{ providerTypeNames[scope.row.types] }}
        </template>
      </el-table-column>
      <el-table-column
        prop="hourFee"
        label="账号余额">
        <template slot-scope="scope">
          {{ scope.row.balance / 100 }} 元
        </template>
      </el-table-column>
      <el-table-column
        prop="et"
        label="入驻时间">
        <template slot-scope="scope">
          {{ scope.row.et.substring(0, 10) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="paid"
        label="已付款">
        <template slot-scope="scope">
          {{ scope.row.paid == 1 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态">
        <template slot-scope="scope">
          <el-tag size="small" :type="scope.row.status == 1 ? 'info' : (scope.row.status == 2 ? 'danger' : 'success') ">
            {{ scope.row.status == 1 ? '待审核' : (scope.row.status == 2 ? '被拒绝' : '已通过') }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>
  </el-row>

</template>

<script>
export default {
  name: "MyProviders",
  props: {
    providers: Array,
  },
  data() {
    return {
      providerTypeNames: {
        '1': '省代',
        '2': '城市合伙人',
        '3': '修理厂'
      },
    }
  },
  methods: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/users/my_providers/MyProviders.vue